module.exports = __webpack_public_path__ + "img/hitachi--alt.f0e2d359.svg";